function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

/**
 * @memberOf module:wdh-feature-b2b
 */
var ModalDialog = /*#__PURE__*/function (_React$Component) {
  function ModalDialog(props) {
    var _this;
    _classCallCheck(this, ModalDialog);
    _this = _callSuper(this, ModalDialog, [props]);
    _this.state = {};
    _this.wrapper = document.getElementById(_this.props.blurElementID);
    return _this;
  }
  _inherits(ModalDialog, _React$Component);
  return _createClass(ModalDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.setBlur();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isOpen !== this.props.isOpen) {
        this.setBlur();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.isOpen) {
        this.removeBlur();
      }
    }
  }, {
    key: "setBlur",
    value: function setBlur() {
      if (this.wrapper) {
        if (this.props.isOpen && this.props.blurBackground) {
          this.wrapper.style.filter = 'blur(3px)';
        } else {
          this.wrapper.style.filter = '';
        }
      }
    }
  }, {
    key: "removeBlur",
    value: function removeBlur() {
      if (this.wrapper) {
        this.wrapper.style.filter = '';
      }
    }
  }, {
    key: "renderTemplate",
    value: function renderTemplate() {
      var _this2 = this;
      if (this.props.type === ModalDialog.types.okCancel) {
        return /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, this.props.children)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("button", {
          id: this.props.cancelId,
          className: "wdh-feature-b2b-button popup-btn",
          type: "button",
          onClick: function onClick(event) {
            return _this2.props.onCancelClick(event);
          }
        }, this.props.cancelLabel), /*#__PURE__*/React.createElement("button", {
          id: this.props.okId,
          className: "wdh-feature-b2b-button popup-btn",
          type: "button",
          onClick: function onClick(event) {
            return _this2.props.onOkClick(event);
          }
        }, this.props.okLabel)))));
      } else if (this.props.type === ModalDialog.types.okOnly) {
        return /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, this.props.children)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("button", {
          className: "wdh-feature-b2b-button",
          type: "button",
          onClick: function onClick(event) {
            return _this2.props.onOkClick(event);
          }
        }, this.props.okLabel)))));
      } else if (this.props.type === ModalDialog.types.blank) {
        return this.props.children;
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement(Modal, this.props, this.props.showCloseButton && /*#__PURE__*/React.createElement("span", {
        className: "close",
        role: "button",
        tabIndex: "0",
        onClick: function onClick(event) {
          return _this3.props.useCancelOnClose ? _this3.props.onCancelClick(event) : _this3.props.onRequestClose(event);
        }
      }), this.renderTemplate());
    }
  }]);
}(React.Component);
var types = {
  okCancel: 'okCancel',
  okOnly: 'okOnly',
  blank: 'blank'
};
ModalDialog.types = types;
ModalDialog.propTypes = {
  // types for those existing props that have default values
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  overlayClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    base: PropTypes.string.isRequired,
    afterOpen: PropTypes.string.isRequired,
    beforeClose: PropTypes.string.isRequired
  })]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    base: PropTypes.string.isRequired,
    afterOpen: PropTypes.string.isRequired,
    beforeClose: PropTypes.string.isRequired
  })]),
  style: PropTypes.shape({
    content: PropTypes.object,
    overlay: PropTypes.object
  }),
  ariaHideApp: PropTypes.bool,
  // added props
  type: PropTypes.oneOf(Object.keys(types)),
  onOkClick: PropTypes.func,
  okLabel: PropTypes.string,
  okId: PropTypes.string,
  onCancelClick: PropTypes.func,
  onRequestClose: PropTypes.func,
  cancelLabel: PropTypes.string,
  cancelId: PropTypes.string,
  blurBackground: PropTypes.bool,
  blurElementID: PropTypes.string,
  showCloseButton: PropTypes.bool,
  useCancelOnClose: PropTypes.bool
};
ModalDialog.defaultProps = {
  // default values for existing props
  overlayClassName: 'wdh-feature-btb-modalOverlay',
  className: 'wdh-feature-btb-modalContent',
  style: {
    content: {}
  },
  ariaHideApp: false,
  // default values for added props
  onOkClick: function onOkClick() {},
  okLabel: 'Ok',
  okId: 'modal-dialog-ok',
  onCancelClick: function onCancelClick() {},
  onRequestClose: function onRequestClose() {},
  cancelLabel: 'Cancel',
  cancelId: 'modal-dialog-cancel',
  type: ModalDialog.types.blank,
  blurBackground: true,
  blurElementID: 'wrapper',
  showCloseButton: false,
  useCancelOnClose: true
};
export default ModalDialog;